export default "__VITE_ASSET__75554a8c__"